import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './UserProfile.css';

const UserProfile = ({ onClose }) => {
  const { user, logout, updateProfile, loading } = useAuth();

  const handleLogout = () => {
    logout();
    onClose();
  };

  if (!user) return null;

  const getBusinessTypeLabel = (type) => {
    const types = {
      'electricien': '⚡ Électricien',
      'plombier': '🔧 Plombier',
      'chauffagiste': '🔥 Chauffagiste',
      'climatisation': '❄️ Climatisation',
      'menuisier': '🔨 Menuisier',
      'peintre': '🎨 Peintre',
      'macon': '🧱 Maçon',
      'couvreur': '🏠 Couvreur',
      'serrurier': '🗝️ Serrurier',
      'jardinier': '🌱 Jardinier',
      'nettoyage': '🧽 Nettoyage',
      'coiffeur': '✂️ Coiffeur',
      'esthetique': '💅 Esthétique',
      'massage': '💆 Massage',
      'renovation': '🏗️ Rénovation',
      'autre': '🔧 Autre'
    };
    return types[type] || type;
  };

  const getInitials = (firstName, lastName) => {
    return `${firstName?.charAt(0) || ''}${lastName?.charAt(0) || ''}`.toUpperCase();
  };

  return (
    <div className="user-profile-overlay" onClick={onClose}>
      <div className="user-profile-content" onClick={(e) => e.stopPropagation()}>
        <button className="profile-close" onClick={onClose}>
          ✕
        </button>

        <div className="profile-header">
          <div className="profile-avatar">
            {user.avatar ? (
              <img src={user.avatar} alt="Avatar" />
            ) : (
              <span className="avatar-initials">
                {getInitials(user.firstName, user.lastName)}
              </span>
            )}
          </div>
          <div className="profile-info">
            <h2>{user.firstName} {user.lastName}</h2>
            <p className="business-name">{user.businessName}</p>
            <p className="business-type">{getBusinessTypeLabel(user.businessType)}</p>
          </div>
        </div>

        <div className="profile-details">
          <div className="detail-group">
            <label>📧 Email</label>
            <p>{user.email}</p>
          </div>

          <div className="detail-group">
            <label>📱 Téléphone</label>
            <p>{user.phone || 'Non renseigné'}</p>
          </div>

          <div className="detail-group">
            <label>📍 Adresse</label>
            <p>{user.address || 'Non renseignée'}</p>
          </div>

          <div className="detail-group">
            <label>📊 Statut</label>
            <p className={`status ${user.subscriptionStatus || 'inactive'}`}>
              {user.subscriptionStatus === 'active' ? '✅ Actif' : '🔒 Inactif'}
            </p>
          </div>

          <div className="detail-group">
            <label>📅 Membre depuis</label>
            <p>{new Date(user.createdAt).toLocaleDateString('fr-FR')}</p>
          </div>
        </div>

        <div className="profile-actions">
          <button className="profile-btn edit" disabled={loading}>
            ✏️ Modifier le profil
          </button>
          <button className="profile-btn settings" disabled={loading}>
            ⚙️ Paramètres
          </button>
          <button 
            className="profile-btn logout" 
            onClick={handleLogout}
            disabled={loading}
          >
            🚪 Déconnexion
          </button>
        </div>

        <div className="profile-stats">
          <div className="stat">
            <span className="stat-value">{user.stats?.interventions || 0}</span>
            <span className="stat-label">Interventions</span>
          </div>
          <div className="stat">
            <span className="stat-value">{user.stats?.clients || 0}</span>
            <span className="stat-label">Clients</span>
          </div>
          <div className="stat">
            <span className="stat-value">{user.stats?.revenue || '0€'}</span>
            <span className="stat-label">CA du mois</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserProfile;